import request from './request';
import { setCurrencyDatabase } from '../utils/SettingsRetriever';

export default (settings) => {
    return new Promise((resolve, reject) => {
        if(settings.app && settings.app.currency){
            const CurrencySettings = settings.app.currency;
            request({
                url: 'https://7loc0h7tkk.execute-api.us-east-1.amazonaws.com/default/CurrencyExchange?base=' + CurrencySettings.list[CurrencySettings.default].base,
                method: 'GET'
            }).then(response => {
                setCurrencyDatabase(response.data);
                resolve(response.data);
            }).catch(err => {
                resolve(null);
            });
        } else {
            resolve(null);
        }
    });
}